import React, { useEffect, useRef, useState } from "react";
import "./style.css";
import { Link } from "react-router-dom";
import { useStateContext } from "../../../context/ContextProvider";
import { slides } from "../../../constants/index";
import { truncateText } from "../../hooks/TextVeiw";
import GradiantButton from "../../layout/GradiantButton";
import { IoIosArrowBack, IoIosArrowForward } from "../../icons";
import SecondaryButton from "../../layout/SecondaryButton";
import SmallButton from "../../layout/SmallButton";
const Carousel = () => {
  const carouselRef = useRef(null);
  const listRef = useRef(null);
  const thumbnailRef = useRef(null);
  const nextRef = useRef(null);
  const prevRef = useRef(null);
  const progressBarRef = useRef(null);
  const { currentLang, currentMode } = useStateContext();
  const timeRunning = 3000;
  const timeAutoNext = 7000;

  const runTimeOut = useRef(null);
  const runNextAuto = useRef(null);
  const progressInterval = useRef(null);

  const [currentSlide, setCurrentSlide] = useState(0);

  const startProgressBar = () => {
    if (progressBarRef.current) {
      progressBarRef.current.style.width = "0%";
      progressBarRef.current.style.animation = "none";

      setTimeout(() => {
        progressBarRef.current.style.animation = `runningTime ${timeAutoNext}ms linear 1 forwards`;
      }, 50);
    }
  };

  const showSlider = (type) => {
    const carouselDom = carouselRef.current;
    const SliderDom = listRef.current;
    const thumbnailBorderDom = thumbnailRef.current;

    let SliderItemsDom = SliderDom.querySelectorAll(".item");
    let thumbnailItemsDom = thumbnailBorderDom.querySelectorAll(".item");

    if (type === "next") {
      SliderDom.appendChild(SliderItemsDom[0]);
      thumbnailBorderDom.appendChild(thumbnailItemsDom[0]);
      carouselDom.classList.add("next");
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    } else {
      SliderDom.prepend(SliderItemsDom[SliderItemsDom.length - 1]);
      thumbnailBorderDom.prepend(
        thumbnailItemsDom[thumbnailItemsDom.length - 1]
      );
      carouselDom.classList.add("prev");
      setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
    }

    startProgressBar();

    clearTimeout(runTimeOut.current);
    runTimeOut.current = setTimeout(() => {
      carouselDom.classList.remove("next");
      carouselDom.classList.remove("prev");
    }, timeRunning);

    clearTimeout(runNextAuto.current);
    runNextAuto.current = setTimeout(() => {
      nextRef.current.click();
    }, timeAutoNext);
  };

  useEffect(() => {
    const nextDom = nextRef.current;
    const prevDom = prevRef.current;

    nextDom.onclick = () => showSlider("next");
    prevDom.onclick = () => showSlider("prev");

    runNextAuto.current = setTimeout(() => {
      nextDom.click();
    }, timeAutoNext);

    startProgressBar();

    return () => {
      clearTimeout(runTimeOut.current);
      clearTimeout(runNextAuto.current);
      clearInterval(progressInterval.current);
    };
  }, []);

  return (
    <div className="carousel-container mb-20  w-full overflow-hidden">
      <div className="carousel lg:min-h-[800px]" ref={carouselRef}>
        <div className="list" ref={listRef}>
          {slides.map((slide, index) => (
            <div className="item" key={index}>
              <img
                src={
                  currentMode === "Light"
                    ? slide.bakground
                    : slide.dark_background
                }
                alt={`Slide ${index + 1}`}
              />
              <div
                className="content"
                dir={currentLang === "ar" ? "rtl" : "ltr"}
              >
                <div className="title lg:h2 h5">
                  {currentLang === "ar" ? slide.title_Ar : slide.title_En}
                </div>
                <div className="topic h1   ">
                  {currentLang === "ar" ? slide.subtitle_Ar : slide.subtitle_En}
                </div>
                <div className="des body-1 h-[85px] overflow-hidden md:h-auto text-light-text dark:text-dark-text">
                  {truncateText( currentLang === "ar"
                    ? slide.description_Ar
                    : slide.description_En ,30)}
                </div>
                <div className="">
           
                 <Link to={`/BlogDetails_page/${slide.title_En}`}
          state={{ blogData: 
    {      title_Ar: slide.title_Ar + " " +slide.subtitle_Ar ,
          title_En:slide.title_En + " " + slide.subtitle_En,
          description_Ar: slide.description_Ar,
          description_En: slide.description_En,
          image: slide.image,
          background: slide.image,}}}
          onClick={() => {
            window.scrollTo(0, 0);
          }}>
             <SecondaryButton
                      text={"LEARN MORE"}
                      icon={
                        currentLang === "en" ? (
                          <IoIosArrowForward size={20} />
                        ) : (
                          <IoIosArrowBack size={20} />
                        )
                      }
                    />
          </Link>
                   
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="flex-row items-center justify-between">
          <div
            dir="ltr"
            className="thumbnail bg-gradient-to-b backdrop:blur-xl from-light-glass1 dark:from-dark-glass1 to-light-glass2 dark:to-dark-glass2 border border-light-glassStrock2 dark:border-dark-glass2 shadow-md"
            ref={thumbnailRef}
          >
            {slides.map((slide, index) => (
              <div className="item" key={index}>
                <img src={slide.image} alt={`Thumbnail ${index + 1}`} />
                <div
                  dir={currentLang === "ar" ? "rtl" : "ltr"}
                  className="content backdrop-blur-xl bg-gradient-to-b from-light-glass2 dark:from-dark-glass1 to-light-glass2 dark:to-dark-glass1 border border-light-glassStrock1 dark:border-dark-glass1 shadow-md"
                >
                  <div
                    className={`text-xs font-kufi text-light-title dark:text-dark-title ${
                      currentLang === "ar" ? "text-right" : ""
                    } `}
                  >
                    {currentLang === "ar" ? slide.title_Ar : slide.title_En}{" "}
                    {currentLang === "ar"
                      ? slide.subtitle_Ar
                      : slide.subtitle_En}
                  </div>
              
                </div>
              </div>
            ))}
          </div>

          <div className="arrows" dir={currentLang === "ar" ? "rtl" : "ltr"}>
            <button ref={prevRef} id="prev" aria-label="Previous slide">
              <SmallButton> {"<"}</SmallButton>
            </button>
            <button ref={nextRef} id="next" aria-label="Next slide">
              <SmallButton> {">"}</SmallButton>
            </button>
          </div>
        </div>

        <div className="progress-container">
          <div className="progress-bar" ref={progressBarRef}></div>
        </div>

        <div className="slide-indicator">
          {currentSlide + 1} / {slides.length}
        </div>
      </div>
    </div>
  );
};

export default Carousel;
